module.exports = __webpack_public_path__ + "static/img/91BM-066-Norwin.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/91BM-066-Norwin.jpg
// module id = /vQ3
// module chunks = 0